// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: indicator.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { ChartStyle, ChartSubType, chartSubTypeFromJSON, chartSubTypeToJSON } from "./chart";

export const protobufPackage = "com.tick2trade.api.indicator";

export enum IndicatorCode {
  INDICATOR_UNKNOWN = 0,
  SIMPLE_MOVING_AVERAGE = 1,
  EXPONENTIAL_MOVING_AVERAGE = 2,
  UNRECOGNIZED = -1,
}

export function indicatorCodeFromJSON(object: any): IndicatorCode {
  switch (object) {
    case 0:
    case "INDICATOR_UNKNOWN":
      return IndicatorCode.INDICATOR_UNKNOWN;
    case 1:
    case "SIMPLE_MOVING_AVERAGE":
      return IndicatorCode.SIMPLE_MOVING_AVERAGE;
    case 2:
    case "EXPONENTIAL_MOVING_AVERAGE":
      return IndicatorCode.EXPONENTIAL_MOVING_AVERAGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IndicatorCode.UNRECOGNIZED;
  }
}

export function indicatorCodeToJSON(object: IndicatorCode): string {
  switch (object) {
    case IndicatorCode.INDICATOR_UNKNOWN:
      return "INDICATOR_UNKNOWN";
    case IndicatorCode.SIMPLE_MOVING_AVERAGE:
      return "SIMPLE_MOVING_AVERAGE";
    case IndicatorCode.EXPONENTIAL_MOVING_AVERAGE:
      return "EXPONENTIAL_MOVING_AVERAGE";
    case IndicatorCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IndicatorInput {
  title: string;
  type: IndicatorInput_InputType;
  defval: string;
  minval: string;
  maxval: string;
  options: string[];
  group: string;
  tooltip: string;
  display: boolean;
  code: string;
}

export enum IndicatorInput_InputType {
  INPUT_TYPE_UNKNOWN = 0,
  BOOLEAN = 1,
  STRING = 2,
  LONG = 3,
  FLOAT = 4,
  INTEGER = 5,
  LENGTH = 6,
  SOURCE = 7,
  UNRECOGNIZED = -1,
}

export function indicatorInput_InputTypeFromJSON(object: any): IndicatorInput_InputType {
  switch (object) {
    case 0:
    case "INPUT_TYPE_UNKNOWN":
      return IndicatorInput_InputType.INPUT_TYPE_UNKNOWN;
    case 1:
    case "BOOLEAN":
      return IndicatorInput_InputType.BOOLEAN;
    case 2:
    case "STRING":
      return IndicatorInput_InputType.STRING;
    case 3:
    case "LONG":
      return IndicatorInput_InputType.LONG;
    case 4:
    case "FLOAT":
      return IndicatorInput_InputType.FLOAT;
    case 5:
    case "INTEGER":
      return IndicatorInput_InputType.INTEGER;
    case 6:
    case "LENGTH":
      return IndicatorInput_InputType.LENGTH;
    case 7:
    case "SOURCE":
      return IndicatorInput_InputType.SOURCE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IndicatorInput_InputType.UNRECOGNIZED;
  }
}

export function indicatorInput_InputTypeToJSON(object: IndicatorInput_InputType): string {
  switch (object) {
    case IndicatorInput_InputType.INPUT_TYPE_UNKNOWN:
      return "INPUT_TYPE_UNKNOWN";
    case IndicatorInput_InputType.BOOLEAN:
      return "BOOLEAN";
    case IndicatorInput_InputType.STRING:
      return "STRING";
    case IndicatorInput_InputType.LONG:
      return "LONG";
    case IndicatorInput_InputType.FLOAT:
      return "FLOAT";
    case IndicatorInput_InputType.INTEGER:
      return "INTEGER";
    case IndicatorInput_InputType.LENGTH:
      return "LENGTH";
    case IndicatorInput_InputType.SOURCE:
      return "SOURCE";
    case IndicatorInput_InputType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IndicatorColor {
  title: string;
  colorCode: string;
}

export interface IndicatorOutput {
  title: string;
  type: IndicatorOutput_OutputType;
  colors: IndicatorColor[];
  thickness: number;
  drawingType?: string | undefined;
  drawingSettings?: IndicatorOutput_DrawingSettings | undefined;
  style?: IndicatorOutput_OutputStyle | undefined;
  subType?: ChartSubType | undefined;
  visibility?: boolean | undefined;
  code: string;
}

export enum IndicatorOutput_OutputType {
  OUTPUT_TYPE_UNKNOWN = 0,
  LINE = 1,
  HISTOGRAM = 2,
  HZ_LINE = 3,
  FILL = 4,
  DRAWING = 5,
  AREA = 6,
  COLUMN = 7,
  UNRECOGNIZED = -1,
}

export function indicatorOutput_OutputTypeFromJSON(object: any): IndicatorOutput_OutputType {
  switch (object) {
    case 0:
    case "OUTPUT_TYPE_UNKNOWN":
      return IndicatorOutput_OutputType.OUTPUT_TYPE_UNKNOWN;
    case 1:
    case "LINE":
      return IndicatorOutput_OutputType.LINE;
    case 2:
    case "HISTOGRAM":
      return IndicatorOutput_OutputType.HISTOGRAM;
    case 3:
    case "HZ_LINE":
      return IndicatorOutput_OutputType.HZ_LINE;
    case 4:
    case "FILL":
      return IndicatorOutput_OutputType.FILL;
    case 5:
    case "DRAWING":
      return IndicatorOutput_OutputType.DRAWING;
    case 6:
    case "AREA":
      return IndicatorOutput_OutputType.AREA;
    case 7:
    case "COLUMN":
      return IndicatorOutput_OutputType.COLUMN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IndicatorOutput_OutputType.UNRECOGNIZED;
  }
}

export function indicatorOutput_OutputTypeToJSON(object: IndicatorOutput_OutputType): string {
  switch (object) {
    case IndicatorOutput_OutputType.OUTPUT_TYPE_UNKNOWN:
      return "OUTPUT_TYPE_UNKNOWN";
    case IndicatorOutput_OutputType.LINE:
      return "LINE";
    case IndicatorOutput_OutputType.HISTOGRAM:
      return "HISTOGRAM";
    case IndicatorOutput_OutputType.HZ_LINE:
      return "HZ_LINE";
    case IndicatorOutput_OutputType.FILL:
      return "FILL";
    case IndicatorOutput_OutputType.DRAWING:
      return "DRAWING";
    case IndicatorOutput_OutputType.AREA:
      return "AREA";
    case IndicatorOutput_OutputType.COLUMN:
      return "COLUMN";
    case IndicatorOutput_OutputType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum IndicatorOutput_OutputStyle {
  OUTPUT_STYLE_UNKNOWN = 0,
  WITH_BREAKS = 1,
  WITH_DIAMONDS = 2,
  SOLID = 3,
  DOTTED = 4,
  DASHED = 5,
  LARGE_DASHED = 6,
  SPARSE_DOTTED = 7,
  UNRECOGNIZED = -1,
}

export function indicatorOutput_OutputStyleFromJSON(object: any): IndicatorOutput_OutputStyle {
  switch (object) {
    case 0:
    case "OUTPUT_STYLE_UNKNOWN":
      return IndicatorOutput_OutputStyle.OUTPUT_STYLE_UNKNOWN;
    case 1:
    case "WITH_BREAKS":
      return IndicatorOutput_OutputStyle.WITH_BREAKS;
    case 2:
    case "WITH_DIAMONDS":
      return IndicatorOutput_OutputStyle.WITH_DIAMONDS;
    case 3:
    case "SOLID":
      return IndicatorOutput_OutputStyle.SOLID;
    case 4:
    case "DOTTED":
      return IndicatorOutput_OutputStyle.DOTTED;
    case 5:
    case "DASHED":
      return IndicatorOutput_OutputStyle.DASHED;
    case 6:
    case "LARGE_DASHED":
      return IndicatorOutput_OutputStyle.LARGE_DASHED;
    case 7:
    case "SPARSE_DOTTED":
      return IndicatorOutput_OutputStyle.SPARSE_DOTTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return IndicatorOutput_OutputStyle.UNRECOGNIZED;
  }
}

export function indicatorOutput_OutputStyleToJSON(object: IndicatorOutput_OutputStyle): string {
  switch (object) {
    case IndicatorOutput_OutputStyle.OUTPUT_STYLE_UNKNOWN:
      return "OUTPUT_STYLE_UNKNOWN";
    case IndicatorOutput_OutputStyle.WITH_BREAKS:
      return "WITH_BREAKS";
    case IndicatorOutput_OutputStyle.WITH_DIAMONDS:
      return "WITH_DIAMONDS";
    case IndicatorOutput_OutputStyle.SOLID:
      return "SOLID";
    case IndicatorOutput_OutputStyle.DOTTED:
      return "DOTTED";
    case IndicatorOutput_OutputStyle.DASHED:
      return "DASHED";
    case IndicatorOutput_OutputStyle.LARGE_DASHED:
      return "LARGE_DASHED";
    case IndicatorOutput_OutputStyle.SPARSE_DOTTED:
      return "SPARSE_DOTTED";
    case IndicatorOutput_OutputStyle.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface IndicatorOutput_DrawingSettings {
  settings: { [key: string]: string };
}

export interface IndicatorOutput_DrawingSettings_SettingsEntry {
  key: string;
  value: string;
}

export interface Indicator {
  code: string;
  name: string;
  description: string;
  defaultChartStyle: ChartStyle | undefined;
  type: string;
  shortName: string;
  inputs: IndicatorInput[];
  candleType: string;
  groupName: string;
  outputs: IndicatorOutput[];
  format: string;
  supportedInstruments: string[];
  enabled: boolean;
  refreshIntervalInSeconds: number;
  isAlertSupported: boolean;
}

export enum Indicator_Type {
  INDICATOR_TYPE_UNKNOWN = 0,
  OVERLAY = 1,
  NON_OVERLAY = 2,
  UNRECOGNIZED = -1,
}

export function indicator_TypeFromJSON(object: any): Indicator_Type {
  switch (object) {
    case 0:
    case "INDICATOR_TYPE_UNKNOWN":
      return Indicator_Type.INDICATOR_TYPE_UNKNOWN;
    case 1:
    case "OVERLAY":
      return Indicator_Type.OVERLAY;
    case 2:
    case "NON_OVERLAY":
      return Indicator_Type.NON_OVERLAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Indicator_Type.UNRECOGNIZED;
  }
}

export function indicator_TypeToJSON(object: Indicator_Type): string {
  switch (object) {
    case Indicator_Type.INDICATOR_TYPE_UNKNOWN:
      return "INDICATOR_TYPE_UNKNOWN";
    case Indicator_Type.OVERLAY:
      return "OVERLAY";
    case Indicator_Type.NON_OVERLAY:
      return "NON_OVERLAY";
    case Indicator_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Indicator_CandleType {
  CANDLE_TYPE_UNKNOWN = 0,
  STOCK = 1,
  OI = 2,
  OTHER = 3,
  DRAWING = 4,
  DRAWING_TOOL = 5,
  UNRECOGNIZED = -1,
}

export function indicator_CandleTypeFromJSON(object: any): Indicator_CandleType {
  switch (object) {
    case 0:
    case "CANDLE_TYPE_UNKNOWN":
      return Indicator_CandleType.CANDLE_TYPE_UNKNOWN;
    case 1:
    case "STOCK":
      return Indicator_CandleType.STOCK;
    case 2:
    case "OI":
      return Indicator_CandleType.OI;
    case 3:
    case "OTHER":
      return Indicator_CandleType.OTHER;
    case 4:
    case "DRAWING":
      return Indicator_CandleType.DRAWING;
    case 5:
    case "DRAWING_TOOL":
      return Indicator_CandleType.DRAWING_TOOL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Indicator_CandleType.UNRECOGNIZED;
  }
}

export function indicator_CandleTypeToJSON(object: Indicator_CandleType): string {
  switch (object) {
    case Indicator_CandleType.CANDLE_TYPE_UNKNOWN:
      return "CANDLE_TYPE_UNKNOWN";
    case Indicator_CandleType.STOCK:
      return "STOCK";
    case Indicator_CandleType.OI:
      return "OI";
    case Indicator_CandleType.OTHER:
      return "OTHER";
    case Indicator_CandleType.DRAWING:
      return "DRAWING";
    case Indicator_CandleType.DRAWING_TOOL:
      return "DRAWING_TOOL";
    case Indicator_CandleType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Indicator_Format {
  INDICATOR_FORMAT_UNKNOWN = 0,
  PRICE = 1,
  VOLUME = 2,
  PERCENT = 3,
  INHERIT = 4,
  UNRECOGNIZED = -1,
}

export function indicator_FormatFromJSON(object: any): Indicator_Format {
  switch (object) {
    case 0:
    case "INDICATOR_FORMAT_UNKNOWN":
      return Indicator_Format.INDICATOR_FORMAT_UNKNOWN;
    case 1:
    case "PRICE":
      return Indicator_Format.PRICE;
    case 2:
    case "VOLUME":
      return Indicator_Format.VOLUME;
    case 3:
    case "PERCENT":
      return Indicator_Format.PERCENT;
    case 4:
    case "INHERIT":
      return Indicator_Format.INHERIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Indicator_Format.UNRECOGNIZED;
  }
}

export function indicator_FormatToJSON(object: Indicator_Format): string {
  switch (object) {
    case Indicator_Format.INDICATOR_FORMAT_UNKNOWN:
      return "INDICATOR_FORMAT_UNKNOWN";
    case Indicator_Format.PRICE:
      return "PRICE";
    case Indicator_Format.VOLUME:
      return "VOLUME";
    case Indicator_Format.PERCENT:
      return "PERCENT";
    case Indicator_Format.INHERIT:
      return "INHERIT";
    case Indicator_Format.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Indicators {
  indicators: Indicator[];
}

export interface Script {
  type: string;
  code: string;
  script: string;
}

export enum Script_Type {
  SCRIPT_TYPE_UNKNOWN = 0,
  INDICATOR = 1,
  UNRECOGNIZED = -1,
}

export function script_TypeFromJSON(object: any): Script_Type {
  switch (object) {
    case 0:
    case "SCRIPT_TYPE_UNKNOWN":
      return Script_Type.SCRIPT_TYPE_UNKNOWN;
    case 1:
    case "INDICATOR":
      return Script_Type.INDICATOR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Script_Type.UNRECOGNIZED;
  }
}

export function script_TypeToJSON(object: Script_Type): string {
  switch (object) {
    case Script_Type.SCRIPT_TYPE_UNKNOWN:
      return "SCRIPT_TYPE_UNKNOWN";
    case Script_Type.INDICATOR:
      return "INDICATOR";
    case Script_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIndicatorInput(): IndicatorInput {
  return {
    title: "",
    type: 0,
    defval: "",
    minval: "",
    maxval: "",
    options: [],
    group: "",
    tooltip: "",
    display: false,
    code: "",
  };
}

export const IndicatorInput = {
  encode(message: IndicatorInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.defval !== "") {
      writer.uint32(26).string(message.defval);
    }
    if (message.minval !== "") {
      writer.uint32(34).string(message.minval);
    }
    if (message.maxval !== "") {
      writer.uint32(42).string(message.maxval);
    }
    for (const v of message.options) {
      writer.uint32(50).string(v!);
    }
    if (message.group !== "") {
      writer.uint32(58).string(message.group);
    }
    if (message.tooltip !== "") {
      writer.uint32(66).string(message.tooltip);
    }
    if (message.display !== false) {
      writer.uint32(72).bool(message.display);
    }
    if (message.code !== "") {
      writer.uint32(82).string(message.code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IndicatorInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicatorInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.defval = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.minval = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.maxval = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.options.push(reader.string());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.group = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.tooltip = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.display = reader.bool();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndicatorInput {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? indicatorInput_InputTypeFromJSON(object.type) : 0,
      defval: isSet(object.defval) ? globalThis.String(object.defval) : "",
      minval: isSet(object.minval) ? globalThis.String(object.minval) : "",
      maxval: isSet(object.maxval) ? globalThis.String(object.maxval) : "",
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => globalThis.String(e)) : [],
      group: isSet(object.group) ? globalThis.String(object.group) : "",
      tooltip: isSet(object.tooltip) ? globalThis.String(object.tooltip) : "",
      display: isSet(object.display) ? globalThis.Boolean(object.display) : false,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
    };
  },

  toJSON(message: IndicatorInput): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.type !== 0) {
      obj.type = indicatorInput_InputTypeToJSON(message.type);
    }
    if (message.defval !== "") {
      obj.defval = message.defval;
    }
    if (message.minval !== "") {
      obj.minval = message.minval;
    }
    if (message.maxval !== "") {
      obj.maxval = message.maxval;
    }
    if (message.options?.length) {
      obj.options = message.options;
    }
    if (message.group !== "") {
      obj.group = message.group;
    }
    if (message.tooltip !== "") {
      obj.tooltip = message.tooltip;
    }
    if (message.display !== false) {
      obj.display = message.display;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndicatorInput>, I>>(base?: I): IndicatorInput {
    return IndicatorInput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndicatorInput>, I>>(object: I): IndicatorInput {
    const message = createBaseIndicatorInput();
    message.title = object.title ?? "";
    message.type = object.type ?? 0;
    message.defval = object.defval ?? "";
    message.minval = object.minval ?? "";
    message.maxval = object.maxval ?? "";
    message.options = object.options?.map((e) => e) || [];
    message.group = object.group ?? "";
    message.tooltip = object.tooltip ?? "";
    message.display = object.display ?? false;
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseIndicatorColor(): IndicatorColor {
  return { title: "", colorCode: "" };
}

export const IndicatorColor = {
  encode(message: IndicatorColor, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.colorCode !== "") {
      writer.uint32(18).string(message.colorCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IndicatorColor {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicatorColor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.colorCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndicatorColor {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      colorCode: isSet(object.colorCode) ? globalThis.String(object.colorCode) : "",
    };
  },

  toJSON(message: IndicatorColor): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.colorCode !== "") {
      obj.colorCode = message.colorCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndicatorColor>, I>>(base?: I): IndicatorColor {
    return IndicatorColor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndicatorColor>, I>>(object: I): IndicatorColor {
    const message = createBaseIndicatorColor();
    message.title = object.title ?? "";
    message.colorCode = object.colorCode ?? "";
    return message;
  },
};

function createBaseIndicatorOutput(): IndicatorOutput {
  return {
    title: "",
    type: 0,
    colors: [],
    thickness: 0,
    drawingType: undefined,
    drawingSettings: undefined,
    style: undefined,
    subType: undefined,
    visibility: undefined,
    code: "",
  };
}

export const IndicatorOutput = {
  encode(message: IndicatorOutput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    for (const v of message.colors) {
      IndicatorColor.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.thickness !== 0) {
      writer.uint32(32).uint32(message.thickness);
    }
    if (message.drawingType !== undefined) {
      writer.uint32(42).string(message.drawingType);
    }
    if (message.drawingSettings !== undefined) {
      IndicatorOutput_DrawingSettings.encode(message.drawingSettings, writer.uint32(50).fork()).ldelim();
    }
    if (message.style !== undefined) {
      writer.uint32(56).int32(message.style);
    }
    if (message.subType !== undefined) {
      writer.uint32(64).int32(message.subType);
    }
    if (message.visibility !== undefined) {
      writer.uint32(72).bool(message.visibility);
    }
    if (message.code !== "") {
      writer.uint32(82).string(message.code);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IndicatorOutput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicatorOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.colors.push(IndicatorColor.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.thickness = reader.uint32();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.drawingType = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.drawingSettings = IndicatorOutput_DrawingSettings.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.style = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.subType = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.visibility = reader.bool();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.code = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndicatorOutput {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? indicatorOutput_OutputTypeFromJSON(object.type) : 0,
      colors: globalThis.Array.isArray(object?.colors) ? object.colors.map((e: any) => IndicatorColor.fromJSON(e)) : [],
      thickness: isSet(object.thickness) ? globalThis.Number(object.thickness) : 0,
      drawingType: isSet(object.drawingType) ? globalThis.String(object.drawingType) : undefined,
      drawingSettings: isSet(object.drawingSettings)
        ? IndicatorOutput_DrawingSettings.fromJSON(object.drawingSettings)
        : undefined,
      style: isSet(object.style) ? indicatorOutput_OutputStyleFromJSON(object.style) : undefined,
      subType: isSet(object.subType) ? chartSubTypeFromJSON(object.subType) : undefined,
      visibility: isSet(object.visibility) ? globalThis.Boolean(object.visibility) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : "",
    };
  },

  toJSON(message: IndicatorOutput): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.type !== 0) {
      obj.type = indicatorOutput_OutputTypeToJSON(message.type);
    }
    if (message.colors?.length) {
      obj.colors = message.colors.map((e) => IndicatorColor.toJSON(e));
    }
    if (message.thickness !== 0) {
      obj.thickness = Math.round(message.thickness);
    }
    if (message.drawingType !== undefined) {
      obj.drawingType = message.drawingType;
    }
    if (message.drawingSettings !== undefined) {
      obj.drawingSettings = IndicatorOutput_DrawingSettings.toJSON(message.drawingSettings);
    }
    if (message.style !== undefined) {
      obj.style = indicatorOutput_OutputStyleToJSON(message.style);
    }
    if (message.subType !== undefined) {
      obj.subType = chartSubTypeToJSON(message.subType);
    }
    if (message.visibility !== undefined) {
      obj.visibility = message.visibility;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndicatorOutput>, I>>(base?: I): IndicatorOutput {
    return IndicatorOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndicatorOutput>, I>>(object: I): IndicatorOutput {
    const message = createBaseIndicatorOutput();
    message.title = object.title ?? "";
    message.type = object.type ?? 0;
    message.colors = object.colors?.map((e) => IndicatorColor.fromPartial(e)) || [];
    message.thickness = object.thickness ?? 0;
    message.drawingType = object.drawingType ?? undefined;
    message.drawingSettings = (object.drawingSettings !== undefined && object.drawingSettings !== null)
      ? IndicatorOutput_DrawingSettings.fromPartial(object.drawingSettings)
      : undefined;
    message.style = object.style ?? undefined;
    message.subType = object.subType ?? undefined;
    message.visibility = object.visibility ?? undefined;
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseIndicatorOutput_DrawingSettings(): IndicatorOutput_DrawingSettings {
  return { settings: {} };
}

export const IndicatorOutput_DrawingSettings = {
  encode(message: IndicatorOutput_DrawingSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.settings).forEach(([key, value]) => {
      IndicatorOutput_DrawingSettings_SettingsEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IndicatorOutput_DrawingSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicatorOutput_DrawingSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = IndicatorOutput_DrawingSettings_SettingsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.settings[entry1.key] = entry1.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndicatorOutput_DrawingSettings {
    return {
      settings: isObject(object.settings)
        ? Object.entries(object.settings).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: IndicatorOutput_DrawingSettings): unknown {
    const obj: any = {};
    if (message.settings) {
      const entries = Object.entries(message.settings);
      if (entries.length > 0) {
        obj.settings = {};
        entries.forEach(([k, v]) => {
          obj.settings[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndicatorOutput_DrawingSettings>, I>>(base?: I): IndicatorOutput_DrawingSettings {
    return IndicatorOutput_DrawingSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndicatorOutput_DrawingSettings>, I>>(
    object: I,
  ): IndicatorOutput_DrawingSettings {
    const message = createBaseIndicatorOutput_DrawingSettings();
    message.settings = Object.entries(object.settings ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseIndicatorOutput_DrawingSettings_SettingsEntry(): IndicatorOutput_DrawingSettings_SettingsEntry {
  return { key: "", value: "" };
}

export const IndicatorOutput_DrawingSettings_SettingsEntry = {
  encode(message: IndicatorOutput_DrawingSettings_SettingsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IndicatorOutput_DrawingSettings_SettingsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicatorOutput_DrawingSettings_SettingsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IndicatorOutput_DrawingSettings_SettingsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: IndicatorOutput_DrawingSettings_SettingsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IndicatorOutput_DrawingSettings_SettingsEntry>, I>>(
    base?: I,
  ): IndicatorOutput_DrawingSettings_SettingsEntry {
    return IndicatorOutput_DrawingSettings_SettingsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IndicatorOutput_DrawingSettings_SettingsEntry>, I>>(
    object: I,
  ): IndicatorOutput_DrawingSettings_SettingsEntry {
    const message = createBaseIndicatorOutput_DrawingSettings_SettingsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseIndicator(): Indicator {
  return {
    code: "",
    name: "",
    description: "",
    defaultChartStyle: undefined,
    type: "",
    shortName: "",
    inputs: [],
    candleType: "",
    groupName: "",
    outputs: [],
    format: "",
    supportedInstruments: [],
    enabled: false,
    refreshIntervalInSeconds: 0,
    isAlertSupported: false,
  };
}

export const Indicator = {
  encode(message: Indicator, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.defaultChartStyle !== undefined) {
      ChartStyle.encode(message.defaultChartStyle, writer.uint32(34).fork()).ldelim();
    }
    if (message.type !== "") {
      writer.uint32(42).string(message.type);
    }
    if (message.shortName !== "") {
      writer.uint32(50).string(message.shortName);
    }
    for (const v of message.inputs) {
      IndicatorInput.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    if (message.candleType !== "") {
      writer.uint32(66).string(message.candleType);
    }
    if (message.groupName !== "") {
      writer.uint32(74).string(message.groupName);
    }
    for (const v of message.outputs) {
      IndicatorOutput.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    if (message.format !== "") {
      writer.uint32(90).string(message.format);
    }
    for (const v of message.supportedInstruments) {
      writer.uint32(98).string(v!);
    }
    if (message.enabled !== false) {
      writer.uint32(104).bool(message.enabled);
    }
    if (message.refreshIntervalInSeconds !== 0) {
      writer.uint32(112).int32(message.refreshIntervalInSeconds);
    }
    if (message.isAlertSupported !== false) {
      writer.uint32(120).bool(message.isAlertSupported);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Indicator {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.defaultChartStyle = ChartStyle.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.type = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.shortName = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.inputs.push(IndicatorInput.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.candleType = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.groupName = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.outputs.push(IndicatorOutput.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.format = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.supportedInstruments.push(reader.string());
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.refreshIntervalInSeconds = reader.int32();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.isAlertSupported = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Indicator {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      defaultChartStyle: isSet(object.defaultChartStyle) ? ChartStyle.fromJSON(object.defaultChartStyle) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      shortName: isSet(object.shortName) ? globalThis.String(object.shortName) : "",
      inputs: globalThis.Array.isArray(object?.inputs) ? object.inputs.map((e: any) => IndicatorInput.fromJSON(e)) : [],
      candleType: isSet(object.candleType) ? globalThis.String(object.candleType) : "",
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : "",
      outputs: globalThis.Array.isArray(object?.outputs)
        ? object.outputs.map((e: any) => IndicatorOutput.fromJSON(e))
        : [],
      format: isSet(object.format) ? globalThis.String(object.format) : "",
      supportedInstruments: globalThis.Array.isArray(object?.supportedInstruments)
        ? object.supportedInstruments.map((e: any) => globalThis.String(e))
        : [],
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      refreshIntervalInSeconds: isSet(object.refreshIntervalInSeconds)
        ? globalThis.Number(object.refreshIntervalInSeconds)
        : 0,
      isAlertSupported: isSet(object.isAlertSupported) ? globalThis.Boolean(object.isAlertSupported) : false,
    };
  },

  toJSON(message: Indicator): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.defaultChartStyle !== undefined) {
      obj.defaultChartStyle = ChartStyle.toJSON(message.defaultChartStyle);
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.shortName !== "") {
      obj.shortName = message.shortName;
    }
    if (message.inputs?.length) {
      obj.inputs = message.inputs.map((e) => IndicatorInput.toJSON(e));
    }
    if (message.candleType !== "") {
      obj.candleType = message.candleType;
    }
    if (message.groupName !== "") {
      obj.groupName = message.groupName;
    }
    if (message.outputs?.length) {
      obj.outputs = message.outputs.map((e) => IndicatorOutput.toJSON(e));
    }
    if (message.format !== "") {
      obj.format = message.format;
    }
    if (message.supportedInstruments?.length) {
      obj.supportedInstruments = message.supportedInstruments;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.refreshIntervalInSeconds !== 0) {
      obj.refreshIntervalInSeconds = Math.round(message.refreshIntervalInSeconds);
    }
    if (message.isAlertSupported !== false) {
      obj.isAlertSupported = message.isAlertSupported;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Indicator>, I>>(base?: I): Indicator {
    return Indicator.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Indicator>, I>>(object: I): Indicator {
    const message = createBaseIndicator();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.defaultChartStyle = (object.defaultChartStyle !== undefined && object.defaultChartStyle !== null)
      ? ChartStyle.fromPartial(object.defaultChartStyle)
      : undefined;
    message.type = object.type ?? "";
    message.shortName = object.shortName ?? "";
    message.inputs = object.inputs?.map((e) => IndicatorInput.fromPartial(e)) || [];
    message.candleType = object.candleType ?? "";
    message.groupName = object.groupName ?? "";
    message.outputs = object.outputs?.map((e) => IndicatorOutput.fromPartial(e)) || [];
    message.format = object.format ?? "";
    message.supportedInstruments = object.supportedInstruments?.map((e) => e) || [];
    message.enabled = object.enabled ?? false;
    message.refreshIntervalInSeconds = object.refreshIntervalInSeconds ?? 0;
    message.isAlertSupported = object.isAlertSupported ?? false;
    return message;
  },
};

function createBaseIndicators(): Indicators {
  return { indicators: [] };
}

export const Indicators = {
  encode(message: Indicators, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.indicators) {
      Indicator.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Indicators {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIndicators();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.indicators.push(Indicator.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Indicators {
    return {
      indicators: globalThis.Array.isArray(object?.indicators)
        ? object.indicators.map((e: any) => Indicator.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Indicators): unknown {
    const obj: any = {};
    if (message.indicators?.length) {
      obj.indicators = message.indicators.map((e) => Indicator.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Indicators>, I>>(base?: I): Indicators {
    return Indicators.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Indicators>, I>>(object: I): Indicators {
    const message = createBaseIndicators();
    message.indicators = object.indicators?.map((e) => Indicator.fromPartial(e)) || [];
    return message;
  },
};

function createBaseScript(): Script {
  return { type: "", code: "", script: "" };
}

export const Script = {
  encode(message: Script, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.code !== "") {
      writer.uint32(18).string(message.code);
    }
    if (message.script !== "") {
      writer.uint32(26).string(message.script);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Script {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScript();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.code = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.script = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Script {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      script: isSet(object.script) ? globalThis.String(object.script) : "",
    };
  },

  toJSON(message: Script): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.script !== "") {
      obj.script = message.script;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Script>, I>>(base?: I): Script {
    return Script.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Script>, I>>(object: I): Script {
    const message = createBaseScript();
    message.type = object.type ?? "";
    message.code = object.code ?? "";
    message.script = object.script ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
